import service from '../../request/cope_request';

//车辆静态信息
export function get_car_dynamic_monitoring_car_static_info(vin) {
    return service.post("/api/car_dynamic_monitoring/car_static_info", {
        data: {
            vin: vin
        }
    })
}
//车辆列表
export function get_company_car() {
    return service.post("/api/car/select_online_status")
}
//车载视频列表
export function get_car_dynamic_monitoring_car_video(vin) {
    return service.post("/api/car_dynamic_monitoring/car_video", {
        data: {
            vin: vin
        }
    })
}
//车辆信息
export function get_car_dynamic_monitoring_car_info(vin) {
    return service.post("/api/car_dynamic_monitoring/car_info", {
        data: {
            vin: vin
        }
    })
}
//车辆信息2
export function get_car_monitoring_car_info(vin) {
    return service.post("/api/car_dynamic_monitoring/car_info2", {
        data: {
            vin: vin
        }
    })
}
//车辆故障记录
export function get_car_dynamic_monitoring_car_fault_list(vin) {
    return service.post("/api/car_dynamic_monitoring/car_fault_list", {
        data: {
            vin: vin
        }
    })
}
//车辆GPS
export function get_car_dynamic_monitoring_car_gps(vin) {
    return service.post("/api/car_dynamic_monitoring/car_gps", {
        data: {
            vin: vin
        }
    })
}